import dataBase from '../dataBase/database'
// import axios from 'axios'
import { projectService } from './project.service' 
import { networkService } from './network.service'
import { tradepointService } from './tradepoint.service'
import { categoryService } from './category.service'
import { productService } from './product.service'
import { config } from '@/_helpers'
// const API = '/api'

export default {

  // ─── ПРОЕКТЫ ────────────────────────────────────────────────────

  async getProjects() {
    if (navigator.onLine) {
      try {
        let data = await projectService.getMyProjects()
        await dataBase.projects.clear()
        await dataBase.projects.bulkPut(
          data.map(p => ({ ...p, 
            cachedAt: new Date().toISOString() 
          }))
        )
        return data
      } catch (e) {
        console.log(e);
        
        console.warn('[DataService] getProjects: нет ответа, берём кэш')
      }
    }
    return dataBase.projects.toArray()
  },

  async loadProject(projectId) {
    if(navigator.onLine) {
      try {
        let project = await projectService.loadProject(projectId)
        await dataBase.projects.put({ ...project, 
          cachedAt: new Date().toISOString() 
        })
        return project
      } catch(e) {
        console.warn('[DataService] loadProject: нет ответа, берём кэш')
      }
    }
    return dataBase.projects.get(Number(projectId))
  },

  // ─── СЕТИ ───────────────────────────────────────────────────────

  async getNetworks(projectId) {
    if (navigator.onLine) {
      try {
        let data = await networkService.loadMyNetwork(projectId)
        await dataBase.networks.where('projectId').equals(projectId).delete()
        await dataBase.networks.bulkPut(
          data.map(n => ({ ...n, 
            projectId: projectId, 
            cachedAt: new Date().toISOString() 
          }))
        )
        return data
      } catch (e) {
        console.warn('[DataService] getNetworks: нет ответа, берём кэш')
      }
    }    
    return dataBase.networks.where('projectId').equals(projectId).toArray()
  },

  async loadNetwork(networkId) {
    if(navigator.onLine) {
      try {
        let network = await networkService.loadNetwork(networkId)
        let oldNetwork = dataBase.networks.get(Number(networkId))
        await dataBase.networks.put({ ...network,
          projectId: oldNetwork.projectId, 
          cachedAt: new Date().toISOString() 
        })
        return network
      } catch(e) {
        console.warn('[DataService] loadNetwork: нет ответа, берём кэш')
      }
    }
    return dataBase.networks.get(Number(networkId))
  },

  // ─── ТОЧКИ ──────────────────────────────────────────────────────

  async getPoints(projectId, networkId) {
    if (navigator.onLine) {
      try {
        let data = await tradepointService.getmytradepoints(projectId, networkId)
        await dataBase.points.where('[networkId+projectId]').equals([networkId, projectId]).delete()
        await dataBase.points.bulkPut(
          data.map(p => ({ ...p, 
            projectId: projectId, 
            networkId: networkId, 
            cachedAt: new Date().toISOString() 
          }))
        )
        return data
      } catch (e) {
        console.warn('[DataService] getPoints: нет ответа, берём кэш')
      }
    }
    
    return dataBase.points.where('[networkId+projectId]').equals([networkId, projectId]).toArray()
  },

  async loadTradePoint(pointId) {
    if (navigator.onLine) {
      try {
        let tradePoint = await tradepointService.loadPoint(pointId)
        let oldPoint = await dataBase.points.get(Number(pointId))
        await dataBase.networks.put({ ...tradePoint,
          projectId: oldPoint.projectId, 
          networkId: oldPoint.networkId, 
          cachedAt: new Date().toISOString() })
        return tradePoint
      } catch (e) {
        console.warn('[DataService] getTradePoint: нет ответа, берём кэш')
      }
    }
    
    return dataBase.points.get(Number(pointId))
  },

  // ─── Категории ───────────────────────────────────────────────────

  async getCategories(pointId, projectId) {
    if (navigator.onLine) {
      try {
        let data = await categoryService.getpointcategories(pointId, projectId)
        await dataBase.categories.where('pointId').equals(pointId).delete()
        await dataBase.categories.bulkPut(
          data.map(p => ({ ...p, 
            pointId: pointId,
            cachedAt: new Date().toISOString() 
          }))
        )
        return data
      } catch (e) {
        console.warn('[DataService] getProducts: нет ответа, берём кэш')
      }
    }
    return dataBase.categories.where('pointId').equals(pointId).toArray()
  },

  async loadCategory(categoryId) {
    if (navigator.onLine) {
      try {
        let category = await categoryService.loadCategory(categoryId)
        let oldCategory = dataBase.categories.get(Number(categoryId))
        await dataBase.categories.put({ ...category,
          pointId: oldCategory.pointId,
          cachedAt: new Date().toISOString() 
        })
        return category
      } catch (e) {
        console.warn('[DataService] getProducts: нет ответа, берём кэш')
      }
    }
    return dataBase.categories.get(Number(categoryId))
  },

  // ─── ПРОДУКТЫ ───────────────────────────────────────────────────

  async getActionProducts(projectId, pointId) {
    if (navigator.onLine) {
      try {
        await dataBase.products.where('[categoryId+pointId]').equals(["a", pointId]).delete()
        let data = await productService.loadPointActionProducts(projectId, pointId)
        await dataBase.products.bulkPut(
          data.map(p => ({ ...p, 
            pointId: pointId, 
            categoryId: "a",
            cachedAt: new Date().toISOString() 
          }))
        )
        return data
      } catch (e) {
        console.warn('[DataService] getProducts: нет ответа, берём кэш')
      }
    }
    return  dataBase.products.where('[categoryId+pointId]').equals(["a", pointId]).toArray()
  },

  async getPointProducts(projectId, pointId, categoryId) {
    if (navigator.onLine) {
      try {
        await dataBase.products.where('[categoryId+pointId]').equals([categoryId, pointId]).delete()
        let data = await productService.loadPointProducts(projectId, pointId, categoryId)
        await dataBase.products.bulkPut(
          data.map(p => ({ ...p, 
            pointId: pointId,
            categoryId: categoryId, 
            cachedAt: new Date().toISOString() 
          }))
        )
        return data
      } catch (e) {
        console.warn('[DataService] getPointProducts: нет ответа, берём кэш')
      }
    }
    return dataBase.products.where('[categoryId+pointId]').equals([categoryId, pointId]).toArray()
  },

  async countPointActionProducts(projectId, pointId) {
    if(navigator.onLine) {
      try {
        await dataBase.countActionsProduct.where('pointId').equals(pointId).delete()
        let data = await productService.countPointActionProducts(projectId, pointId)
        await dataBase.countActionsProduct.put({
          id: pointId,
          count: data,
          cachedAt: new Date().toISOString()
        })
        return data
      } catch (e) {
        console.warn('[DataService] countPointActionProducts: нет ответа, берём кэш')
      }
    }
    return dataBase.countActionsProduct.where('pointId').equals(pointId).first()
  },


  async getProductReportData(projectId, pointId, productId) {
    if (navigator.onLine) {
      try {
        let data = await productService.getProductReportData(projectId, pointId, productId)
        await dataBase.productReportData.put({
          id:`${productId}_${pointId}`,
          productId: String(productId),
          pointId : String(pointId),
          data: data,
          synced: 1,
          cachedAt:  new Date().toISOString(),
        })
        if(data.photo && data.photo.length) {
          await dataBase.photos.where('reportId').equals(`${productId}_${pointId}`).delete()
          for (const photo of data.photo) {
            const response = await fetch(config.image(photo.uuid))
            const blob = await response.blob()
            await dataBase.photos.add({
              reportId: `${productId}_${pointId}`,
              uuid: photo.uuid,
              extension:  photo.extension,
              blob: blob,
              synced: 1,
              dmp: photo.dmp,
              motivational: photo.motivational,
              createdAt:  new Date().toISOString(),
            })
          }

        } else {
          await dataBase.photos.where('reportId').equals(`${productId}_${pointId}`).delete()
        }
        return data
      } catch (e) {
        console.log(e);
        console.warn('[DataService] getProductReportData: нет ответа, берём кэш')
      }
    }
    const cached = await dataBase.productReportData.get(`${productId}_${pointId}`)
    if(cached) {
      cached.data.photo = []
      const photos = await dataBase.photos.where('reportId').equals(String(cached.id)).toArray()
      if(photos.length) {
        for (const photo of photos) {
          cached.data.photo.push(photo)
        }
      }
      
    }
    return cached ? cached.data : null
  },
}